import { useState, useEffect } from 'react';
import { PagingQuery } from 'tea-component';
import { getRecordsByPagination } from '../utils';
import { DEFAULT_PAGE_SIZES } from '../constants';

interface IPagination extends PagingQuery {
  pageIndex: number;
  pageSize: number;
  pageSizes: number[];
}

function mergePaginationWithDefault(pagination?: PagingQuery): IPagination {
  return {
    pageIndex: pagination?.pageIndex || 1,
    // pageSize: pagination?.pageSize || DEFAULT_PAGE_SIZES[0],
    pageSize: pagination?.pageSize || 50,
    pageSizes: DEFAULT_PAGE_SIZES,
  };
}

export default function usePagination(option?: {
  pagination?: PagingQuery;
  onPaginationChange?: (query: PagingQuery) => void;
}) {
  const { pagination: paginationOutter, onPaginationChange: onPaginationChangeOutter } =
    option || {};

  const initialPagination = mergePaginationWithDefault(paginationOutter);

  const [pagination, setPagination] = useState<IPagination>(initialPagination);

  const handlePaginationChange = (payload: PagingQuery) => {
    setPagination(mergePaginationWithDefault(payload));
    onPaginationChangeOutter?.(pagination);
  };

  useEffect(() => {
    if (paginationOutter) {
      setPagination(mergePaginationWithDefault(paginationOutter));
    }
  }, [paginationOutter]);

  return {
    pagination,
    setPagination,
    onPaginationChange: handlePaginationChange,
    getRecordsByPagination,
  };
}
